var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0716 6.92443C5.3516 9.43998 7.41382 11.4933 9.92938 12.7822L11.8849 10.8267C12.1249 10.5867 12.4805 10.5067 12.7916 10.6133C13.7872 10.9422 14.8627 11.12 15.9649 11.12C16.4538 11.12 16.8538 11.52 16.8538 12.0089V15.1111C16.8538 15.6 16.4538 16 15.9649 16C7.61827 16 0.853821 9.23554 0.853821 0.888874C0.853821 0.399985 1.25382 -1.52588e-05 1.74271 -1.52588e-05H4.85382C5.34271 -1.52588e-05 5.74271 0.399985 5.74271 0.888874C5.74271 1.99998 5.92049 3.06665 6.24938 4.06221C6.34715 4.37332 6.27604 4.71999 6.02715 4.96887L4.0716 6.92443Z",
    fill: "#FF6978"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9c53548955c6fc9715d9bb097f9074a7.svg";
export { ForwardRef as ReactComponent };